import store from "@/store/store";
import HttpRequest from '@/../bower_components/teknisavuecomponents/assets/utils/HttpRequest';
import SnackbarUtils from '@/../bower_components/teknisavuecomponents/assets/utils/SnackbarUtils';
import Util from '@/../bower_components/teknisavuecomponents/assets/utils/Util';
import UtilPG from '../utils/Util';


class DemonstrativoController {
  public static async solicitaAbonoFaltas(
    nrVinculo: number,
    dates: string[],
    observacao: string,
    base64: string,
    showLoading = true,
    cdtabecdi: string,
    cddiagnost: string,
    nrpessoa: string
  ) {
    const route = 'solicitaAbonoFaltas';

    const nrOrg = store.getters.user.nrorg;

    const params = {
      requestType: 'Row',
      row: {
        NRORG: nrOrg,
        NRVINCULOM: nrVinculo,
        DATE: dates,
        DSOBSERVACAO: observacao,
        FILE: base64,
        CDTABECDI: cdtabecdi,
        CDDIAGNOST: cddiagnost,
        NRPESSOA: nrpessoa,
      },
    };

    try {
      const response = await HttpRequest.post(route, params, showLoading);
      Util.throwErrorMessage(response);

      const message = `
        Solicitação de abono de falta realizada
        para o(s) dia(s) selecionado(s).`;

      SnackbarUtils.showMessage(message);

      return true;
    } catch (e) {
      const err = e as any;
      const message = err.response ? err.response.data.error :  `
        Houve um erro ao gravar a solicação de abono de falta para o(s) dia(s) selecionados.
        Favor contatar o administrador do sistema.`;

      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async solicitarCompensacaoHoras(
    nrVinculo: number,
    date: string,
    showLoading = true,
  ) {
    const route = 'solicitarCompensacaoHoras';

    const nrOrg = store.getters.user.nrorg;

    const params = {
      requestType: 'Row',
      row: {
        NRORG: nrOrg,
        NRVINCULOM: nrVinculo,
        DATE: date,
      },
    };

    try {
      const response = await HttpRequest.post(route, params, showLoading);

      if (response.data.messages) {
        const message = response.data.messages[0].message;
        SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

        return false;
      }

      if (typeof response.data === 'string') {
        throw response.data;
      }

      const message = `
        Solicitação de compensação
        realizada para o(s) dia(s) selecionado(s).`;

      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_SUCCESS);

      return true;
    } catch (err) {
      const message = `
        Houve um erro ao gravar a solicação de compensação
        para o(s) dia(s) selecionado(s).
        Por favor contate o administrador do sistema.`;

      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async solicitaCompensacaoFaltas(
    nrVinculo: number,
    dates: string[],
    showLoading = true,
  ) {
    const route = 'solicitaCompensacaoFaltas';

    const nrOrg: string = store.getters.user.nrorg;

    const params = {
      requestType: 'Row',
      row: {
        NRORG: nrOrg,
        NRVINCULOM: nrVinculo,
        DATE: dates,
      },
    };

    try {
      const response = await HttpRequest.post(route, params, showLoading);

      if (response.data.messages) {
        const message = response.data.messages[0].message;
        SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

        return false;
      }

      if (typeof response.data === 'string') {
        throw response.data;
      }

      const message = `
        Solicitação de compensação
        realizada para o(s) dia(s) selecionado(s).`;

      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_SUCCESS);

      return true;
    } catch (err) {
      const message = `
        Houve um erro ao gravar a solicação de compensação
        para o(s) dia(s) selecionado(s).
        Por favor contate o administrador do sistema.`;

      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async solicitarHorasExtras(
    nrVinculo: number,
    date: string,
    observacao: string,
    showLoading = true,
  ) {
    const route = 'solicitarHorasExtras';

    const nrOrg: string = store.getters.user.nrorg;

    const params = {
      requestType: 'Row',
      row: {
        NRORG: nrOrg,
        NRVINCULOM: nrVinculo,
        DATE: date,
        DSOBSERVACAO: observacao,
      },
    };

    try {
      const response = await HttpRequest.post(route, params, showLoading);

      if (response.data.messages) {
        const message = response.data.messages[0].message;
        SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

        return false;
      }

      if (typeof response.data === 'string') {
        throw response.data;
      }

      const message = 'Horas extras solicitadas com sucesso!';

      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_SUCCESS);

      return true;
    } catch (err) {
      const message = 'Não foi possível solicitar as horas extras!';

      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async setTrocasHorario(
    nrVinculo: number,
    dates: string[],
    observacao: string,
    base64: string,
    nrHordiam: string,
    showLoading = true
  ) {
    const route = 'setTrocasHorario';

    const nrOrg = store.getters.user.nrorg;

    const params = {
      requestType: 'Row',
      row: {
        NRORG: nrOrg,
        NRVINCULOM: nrVinculo,
        DATE: dates,
        DSOBSERVACAO: observacao,
        FILE: base64,
        NRHORDIAM: nrHordiam,
      },
    };

    try {
      const response = await HttpRequest.post(route, params, showLoading);
      Util.throwErrorMessage(response);

      const message = `
        Cadastro de troca de horários realizada
        para o(s) dia(s) selecionado(s).`;

      SnackbarUtils.showMessage(message);

      return true;
    } catch (e) {
      const err = e as any;
      const message = err.response ? err.response.data.error :  `
        Houve um erro ao gravar a troca de horários para o(s) dia(s) selecionados.
        Favor contatar o administrador do sistema.`;

      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async setHorasExtrasNoBancoDeHoras(
    nrVinculo: number,
    dates: string[],
    observacao: string,
    base64: string,
    qtHoras: string,
    nrMotivoOcorFreq: number,
    showLoading = true
  ) {
    const route = 'setHorasExtrasNoBancoDeHoras';
    const nrOrg = store.getters.user.nrorg;
  
    const params = {
      requestType: 'Row',
      NRORG: nrOrg,
      row: {
        NRVINCULOM: nrVinculo,
        DATE: dates,
        DSOBSERVACAO: observacao,
        FILE: base64,
        QTHORAS: qtHoras,
        NRMOTIVOOCORFREQ: nrMotivoOcorFreq,
      },
    };
  
    try {
      const response = await HttpRequest.post(route, params, showLoading);
      Util.throwErrorMessage(response);
  
      const { success, success_dates, error_dates } = response.data.dataset.data;
  
      const hasSuccess = success_dates.length > 0;
      const hasErrors = error_dates.length > 0;
  
      const formattedErrors = error_dates.map((item: any) =>
        `• ${item.date}: ${UtilPG.limitText(item.error, 100)}`
      ).join('<br>');
  
      const messageList = {
        fullSuccess: `✅ Cadastro de horas extras realizado com sucesso para o(s) dia(s) selecionado(s).`,
        partialSuccess: `✅ Horas extras cadastradas com sucesso para alguns dias.<br><br>❌ Erros encontrados:<br>${formattedErrors}`,
        fullFail: `❌ Não foi possível realizar o cadastro para o(s) dia(s) selecionado(s):<br>${formattedErrors}`
      };
  
      const messageTypeList = {
        fullSuccess: SnackbarUtils.TYPE_SUCCESS,
        partialSuccess: SnackbarUtils.TYPE_ALERT,
        fullFail: SnackbarUtils.TYPE_ERROR
      };
  
      const statusKey = !hasErrors ? 'fullSuccess' : hasSuccess ? 'partialSuccess' : 'fullFail';
  
      SnackbarUtils.showMessage(messageList[statusKey], messageTypeList[statusKey]);
  
      return true;
    } catch (e) {
      const err = e as any;
      const message = err.response ? err.response.data.error : `
        ❌ Houve um erro ao incluir as horas extras no banco de horas para o(s) dia(s) selecionado(s).`;
  
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);
      throw err;
    }
  }
  
  

  public static async setBancoDeHorasNasHorasExtras(
    nrVinculo: number,
    dates: string[],
    observacao: string,
    base64: string,
    qtHoras: string,
    nrMotivoOcorFreq: number,
    showLoading = true
  ) {
    const route = 'setBancoDeHorasNasHorasExtras';

    const nrOrg = store.getters.user.nrorg;

    const params = {
      requestType: 'Row',
      NRORG: nrOrg,
      row: {
        NRVINCULOM: nrVinculo,
        DATE: dates,
        DSOBSERVACAO: observacao,
        FILE: base64,
        QTHORAS: qtHoras,
        NRMOTIVOOCORFREQ: nrMotivoOcorFreq,
      },
    };

    try {
      const response = await HttpRequest.post(route, params, showLoading);
      Util.throwErrorMessage(response);

      const { success, success_dates, error_dates } = response.data.dataset.data;
  
      const hasSuccess = success_dates.length > 0;
      const hasErrors = error_dates.length > 0;
  
      const formattedErrors = error_dates.map((item: any) =>
        `• ${item.date}: ${UtilPG.limitText(item.error, 100)}`
      ).join('<br>');
  
      const messageList = {
        fullSuccess: `✅ Cadastro de banco de horas realizado com sucesso para o(s) dia(s) selecionado(s).`,
        partialSuccess: `✅ Banco de horas cadastrados com sucesso para alguns dias.<br><br>❌ Erros encontrados:<br>${formattedErrors}`,
        fullFail: `❌ Não foi possível realizar o cadastro para o(s) dia(s) selecionado(s):<br>${formattedErrors}`
      };
  
      const messageTypeList = {
        fullSuccess: SnackbarUtils.TYPE_SUCCESS,
        partialSuccess: SnackbarUtils.TYPE_ALERT,
        fullFail: SnackbarUtils.TYPE_ERROR
      };
  
      const statusKey = !hasErrors ? 'fullSuccess' : hasSuccess ? 'partialSuccess' : 'fullFail';
  
      SnackbarUtils.showMessage(messageList[statusKey], messageTypeList[statusKey]);

      return true;
    } catch (e) {
      const err = e as any;
      const message = err.response ? err.response.data.error : `
      Houve um erro ao incluir o(s) banco(s) de horas nas horas extras para o(s) dia(s) selecionados.`;

      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

}

export default DemonstrativoController;